function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.76886 2.20884C9.01503 0.802706 6.99902 0.80198 6.24418 2.20757L1.13532 11.7208C0.419786 13.0532 1.38494 14.6671 2.89731 14.6671H13.1062C14.6179 14.6671 15.5832 13.0545 14.8689 11.7221L9.76886 2.20884ZM8.66732 6.00016C8.66732 5.63197 8.36884 5.3335 8.00065 5.3335C7.63246 5.3335 7.33398 5.63197 7.33398 6.00016V8.66683C7.33398 9.03502 7.63246 9.3335 8.00065 9.3335C8.36884 9.3335 8.66732 9.03502 8.66732 8.66683V6.00016ZM8.00065 10.6668C7.63246 10.6668 7.33398 10.9653 7.33398 11.3335C7.33398 11.7017 7.63246 12.0002 8.00065 12.0002H8.00732C8.37551 12.0002 8.67398 11.7017 8.67398 11.3335C8.67398 10.9653 8.37551 10.6668 8.00732 10.6668H8.00065Z"
});

function SvgExclamationCircleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleFilled);
export default __webpack_public_path__ + "static/media/exclamation-circle-filled.1b75a708.svg";
export { ForwardRef as ReactComponent };